import { L as f } from "../chunks/Linkify-39f20c9a.mjs";
const a = function(i, e) {
  var t;
  ((t = e.value) == null ? void 0 : t.linkify) === !0 && (i.innerHTML = f(e.value.text));
};
export {
  a as default,
  a as directive
};
